<app-home-header *ngIf="urlStepId === 'closing-stream'"></app-home-header>

<div class="wrapper">
    <rr-track-header
        [trackType]="currentTrackData?.name!"
        [trackName]="currentUserTrackData?.name!"
        *ngIf="urlStepId !== 'closing-stream'"
        class="limit-with-1400"
    ></rr-track-header>
    <!-- Step-Components -->
    <app-basic-idea
        class="limit-with-1400"
        *ngIf="urlStepId == 'MMUT2vQla'"
        stepId="MMUT2vQla"
        [streamId]="urlStreamId"
        [trackId]="urlTrackId"
        [roundId]="urlRoundId"
        [thisStepCount]="currentStepData?.orderNr || 1"
        [totalStepCount]="currentStreamData?.steps.length || 0"
        [step]="currentStepData"
        (nextStreamStepDisabledStatus)="nextStreamStepDisabledStatus = $event"
        [runClosingPrompt]="runClosingPrompt"
        (closingPromptReady)="saveData($event)"
    ></app-basic-idea>
    <app-user-tinder
        class="overflow-hidden limit-with-1400"
        *ngIf="urlStepId == 'Ci6Ju_grd'"
        stepId="Ci6Ju_grd"
        [streamId]="urlStreamId"
        [trackId]="urlTrackId"
        [roundId]="urlRoundId"
        [thisStepCount]="currentStepData?.orderNr || 1"
        [totalStepCount]="currentStreamData?.steps.length || 0"
        [initialReady]="initialReady"
        [step]="currentStepData"
        (nextStreamStepDisabledStatus)="nextStreamStepDisabledStatus = $event"
        [runClosingPrompt]="runClosingPrompt"
        (closingPromptReady)="saveData($event)"
    ></app-user-tinder>
    <app-user-insight-mapping
        class="limit-with-1400"
        *ngIf="urlStepId == 'jKHo2wIzi'"
        stepId="jKHo2wIzi"
        [streamId]="urlStreamId"
        [trackId]="urlTrackId"
        [roundId]="urlRoundId"
        [thisStepCount]="currentStepData?.orderNr || 1"
        [totalStepCount]="currentStreamData?.steps.length || 0"
        [initialReady]="initialReady"
        [step]="currentStepData"
        (nextStreamStepDisabledStatus)="nextStreamStepDisabledStatus = $event"
        [runClosingPrompt]="runClosingPrompt"
        (closingPromptReady)="saveData($event)"
    ></app-user-insight-mapping>

    <app-marketanalyse
        class="overflow-hidden limit-with-1400"
        *ngIf="urlStepId == 'Gk7Zp8WnR'"
        stepId="Gk7Zp8WnR"
        [streamId]="urlStreamId"
        [trackId]="urlTrackId"
        [roundId]="urlRoundId"
        [thisStepCount]="currentStepData?.orderNr || 1"
        [totalStepCount]="currentStreamData?.steps.length || 0"
        [initialReady]="initialReady"
        [step]="currentStepData"
        (nextStreamStepDisabledStatus)="nextStreamStepDisabledStatus = $event"
        [runClosingPrompt]="runClosingPrompt"
        (closingPromptReady)="saveData($event)"
    ></app-marketanalyse>
    <app-closing-stream-view
        *ngIf="urlStepId == 'closing-stream'"
        class="overflow-hidden limit-with-1400"
        [initialReady]="initialReady"
        [stepId]="urlStepId"
        [currentTrackData]="currentTrackData"
        [streamId]="urlStreamId"
        [currentTrackName]="currentUserTrackData?.name!"
        [businessTypeId]="currentUserTrackData?.businessTypeId || ''"
        [industryTypeId]="currentUserTrackData?.industryTypeId || ''"
        [ideaTypeId]="currentUserTrackData?.ideaTypeId || ''"
        [lpReferenceId]="currentUserTrackData?.landingpageRefId || null"
        [roundId]="urlRoundId"
        (goToValidation)="findNextStepIdByCurrentStepId()"
    >
    </app-closing-stream-view>
    <app-feedback-card
        class="overflow-hidden limit-with-1400"
        *ngIf="urlStepId == 'k9G9Fv8w6'"
        [streamId]="urlStreamId"
        [trackId]="urlTrackId"
        [stepId]="urlStepId"
        [thisStepCount]="currentStepNumber"
        [totalStepCount]="currentMaxSteps"
        [step]="currentStepData"
        [roundId]="urlRoundId"
        (nextStreamStepDisabledStatus)="nextStreamStepDisabledStatus = $event"
        [initialReady]="initialReady"
    >
    </app-feedback-card>
    <!-- END Step-Components -->

    <!-- Footer Area -->
    <div
        class="footer row align-center limit-with-1400"
        *ngIf="urlStepId !== 'closing-stream' && urlStepId !== 'k9G9Fv8w6'"
    >
        <div class="leftside row gap-16 align-center">
            <rr-btn
                i18n
                type="Primary"
                [disabled]="nextStreamStepDisabledStatus"
                (click)="
                    nextStreamStepDisabledStatus === false
                        ? oneStepForeward()
                        : null
                "
                >{{
                    currentStepNumber > 0 &&
                    currentStepNumber !== currentMaxSteps &&
                    currentMaxSteps > 0
                        ? "Next Step"
                        : "Finish Stream"
                }}</rr-btn
            >
            <rr-btn
                type="Link"
                iconStart="arrow-left"
                size="medium"
                *ngIf="currentStepNumber > 0"
                (click)="findPreviusStepIdByCurrentStepId()"
                >Back</rr-btn
            >
        </div>
        <div class="middle row grow-1 align-center justify-center">
            <div class="inner align-center row">
                <div class="stepcounter">
                    STEP {{ currentStepNumber }}/{{ currentMaxSteps }}
                </div>
                <rr-progress [progress]="progress"></rr-progress>
            </div>
        </div>
        <div
            class="rightside row gap-16 align-center"
            *ngIf="currentStepNumber > 0"
        >
            <rr-btn
                size="Small"
                type="Secondary"
                iconStart="file"
                (click)="openDocumentUpload()"
                >Upload Document</rr-btn
            >
            <app-show-results-list
                [roundId]="urlRoundId"
                [trackProcessData]="currentTrackData"
            ></app-show-results-list>
        </div>
    </div>

    <!-- OVERVIEW FOOTER -->
    <div
        class="footer row align-center space-between limit-with-1400"
        *ngIf="urlStepId === 'closing-stream' || urlStepId === 'k9G9Fv8w6'"
    >
        <div class="leftside row gap-16 align-center">
            <rr-btn type="Secondary" (click)="saveAndExit()"
                >Save & Exit</rr-btn
            >
        </div>

        <div class="rightside grow-1 justify-end row gap-16 align-center">
            <rr-btn
                size="Small"
                type="Secondary"
                iconStart="file"
                (click)="openDocumentUpload()"
                >Upload Document</rr-btn
            >
            <app-show-results-list
                [roundId]="urlRoundId"
                [trackProcessData]="currentTrackData"
            ></app-show-results-list>
        </div>
    </div>
    <!-- END Footer Area -->
</div>

<rr-spinner *ngIf="loading === true"></rr-spinner>
